import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import Logo from "../components/Logo";

export default function Login() {
  const { user, loginWithGoogle, loading } = useAuth();
  const location = useLocation();
  const error = location.state?.error;
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="relative hidden md:block bg-black text-white overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-70"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1633550233861-edf516679c90?w=1600)" }}
        />
        <div className="relative z-10 p-12 h-full flex flex-col justify-between">
          <div>
            <Logo size={34} tone="light" />
          </div>
          <div>
            <h1 className="font-display font-black text-5xl lg:text-6xl leading-[0.95]">
              The marketplace <br />with a point of view.
            </h1>
            <p className="mt-6 text-sm text-white/70 max-w-md">
              Discover independent sellers. Shop without the noise. Checkout in seconds.
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <h2 className="font-display font-black text-3xl">Sign in</h2>
          <p className="text-sm text-neutral-600 mt-2">
            Use your Google account to start shopping, selling, or managing your store.
          </p>
          {error && (
            <div
              data-testid="login-error"
              className="mt-5 border border-[#FF2A00] bg-[#FF2A00]/5 text-[#FF2A00] text-sm px-4 py-3"
            >
              {error}
            </div>
          )}
          <Button
            data-testid="google-login-btn"
            onClick={loginWithGoogle}
            className="w-full mt-8 h-12 rounded-none bg-[#0033FF] hover:bg-[#0022CC] text-base font-semibold"
          >
            Continue with Google
          </Button>
          <p className="text-xs text-neutral-500 mt-6">
            By signing in you agree to our Terms of Service and acknowledge our Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}
